import React from "react";
import { cn } from "@/utils/cn";

type MenuIconProps = {
  className?: string;
};

export const MenuIcon: React.FC<MenuIconProps> = ({ className }) => (
  <svg
    className={cn("h-6 w-6", className)}
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    />
  </svg>
);
